module.exports = __webpack_public_path__ + "img/zt-img5.a2691d85.png";